import { render, staticRenderFns } from "./staffshare.vue?vue&type=template&id=5eb91624&scoped=true"
import script from "./staffshare.vue?vue&type=script&lang=js"
export * from "./staffshare.vue?vue&type=script&lang=js"
import style0 from "./staffshare.vue?vue&type=style&index=0&id=5eb91624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb91624",
  null
  
)

export default component.exports